<template>
    <div class="form-overlay identify-content" :class="position">
        <div class="steep1" v-if="steep == 1">
            <p v-if="personsSelectIsMaxed">{{ $t('dash.post-creator.overlay.max-persons') }}</p>
            <p v-else>{{ $t('dash.post-creator.overlay.manual-person-instruction') }}</p>

            <div class="content" v-if="personsSelectComputed.length">
                <div class="list-item hide-scrollbar">
                    <div
                        class="item"
                        v-for="person in personsSelectComputed"
                        :key="person.id || person.name"
                    >
                        <img :src="person.image ? person.image : 'img/avatar.jpg'" alt="">
                        <div class="info">
                            <p class="username">{{ person.id ? person.id : person.name }}</p>
                            <p class="name">{{ person.name }}</p>
                        </div>
                        <i class="fa-regular fa-xmark" @click="removePerson(person)"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="steep2" v-else-if="steep == 2">
            <div class="content">
                <p class="manual-hint">{{ $t('dash.post-creator.overlay.manual-person-hint') }}</p>
                <div class="input">
                    <i class="fa-regular fa-at"></i>
                    <input :placeholder="$t('dash.post-creator.overlay.manual-person-placeholder')" v-model="username" v-on:keyup.enter="addUsername">
                </div>
                <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
                <div class="btn-secondary" @click="addUsername">{{ $t('dash.button.add') }}</div>
            </div>
        </div>
        <div class="btn-secondary" @click="$emit('close')">{{ $t('dash.button.close') }}</div>
    </div>
</template>

<script>
    // "Manual" Instagram tagging: types a username directly, no live search
    import { EventBus } from '@/event-bus';
    const USERNAME_FORMAT = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._]{1,30}(?<!\.)$/;

    export default {
        props: {
            positionClick: {
                type: Object,
                default: undefined
            },
            personsSelect: {
                type: Array,
                default: ()=>[]
            },
            position: {
                type: String,
                default: 'left'
            },
            maxPersons: {
                type: Number,
                default: 10
            },
            hasMultipleMedia: {
                type: Boolean,
                default: false
            },
            idFileSelected: {
                type: String,
                default: null
            },
            idsFilesAvailable: {
                type: Array,
                default: ()=>[]
            },
            isFirstSlide: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                steep : 1,
                username : '',
                errorMessage : '',
            }
        },

        methods: {
            addUsername() {
                let value = (this.username || '').trim()
                if (value.startsWith('@')) value = value.slice(1)
                this.errorMessage = ''

                if (!value) return
                if (this.personsSelectIsMaxed) return

                if (!USERNAME_FORMAT.test(value)) {
                    this.errorMessage = this.$t('dash.post-creator.overlay.manual-person-invalid')
                    return
                }
                if (this.personsSelectComputed.some(p => (p.id || '').toLowerCase() === value.toLowerCase())) {
                    this.errorMessage = this.$t('dash.post-creator.overlay.manual-person-duplicate')
                    return
                }

                EventBus.$emit("eventClickSelectPerson",{
                    id: value,
                    name: value,
                    image: null,
                    pk: null,
                    manual: true,
                    ...this.positionClick,
                    timestamp : Date.now()
                })
                this.$emit("resetPositionClick")
                this.username = ''
            },

            removePerson(person) {
                EventBus.$emit("eventRemoveSelectPerson",person.id, person.idFile)
            },
        },

        computed: {
            personsSelectIsMaxed() {
                return this.personsSelect.length >= this.maxPersons
            },

            personsSelectComputed() {
                if (!this.idFileSelected) return this.personsSelect
                // même fallback que selectPerson.vue : sur la 1ere slide, remonter aussi les tags orphelins
                return this.personsSelect.filter(person =>
                    person.idFile == this.idFileSelected ||
                    (this.isFirstSlide && !this.idsFilesAvailable.includes(person.idFile))
                )
            }
        },

        watch: {
            positionClick(newValue, oldValue) {
                this.errorMessage = ''
                if (newValue && !this.personsSelectIsMaxed) {
                    this.steep = 2
                }else{
                    this.steep = 1
                    this.username = ''
                }
            }
        },
    }
</script>
